import React from "react";
import ContinueIcon from '../../images/continue-icon.svg';
import css from './CombinedPlans.module.css';
import { formatCurrencyMajorUnit } from "../../../../util/currency";
import { subscriptionTypes } from "../../../../util/subscriptionsHelpers";
import SectionCoupon from "../SectionCoupon/SectionCoupon";

const CombinedPlans = props => {
    const { subscriptionPrices, createSubscription, intl, coupon,
        couponError,
        handleChange,
        promoCode,
        isBusy,
        onApplyCoupon,
    } = props;

    // first filter out the ones without nickname
    const subscriptionPricesNew = subscriptionPrices?.filter(p => p.nickname);

    const premiumSubscription = subscriptionPricesNew?.find(p => p.nickname.includes(subscriptionTypes.premium));
    const choiceSubscription = subscriptionPricesNew?.find(p => p.nickname.includes(subscriptionTypes.choice));
    const valueSubscription = subscriptionPricesNew?.find(p => p.nickname.includes(subscriptionTypes.value));

    const premiumSubscriptionFormattedPrice = premiumSubscription &&
        formatCurrencyMajorUnit(intl, premiumSubscription.currency.toUpperCase(), premiumSubscription.unit_amount / 100);
    const premiumSubscriptionFormattedPriceWithCoupon = coupon && premiumSubscription &&
        formatCurrencyMajorUnit(intl, premiumSubscription.currency.toUpperCase(), (premiumSubscription.unit_amount - (premiumSubscription.unit_amount * coupon.percent_off) / 100) / 100);

    const choiceSubscriptionFormattedPrice = choiceSubscription &&
        formatCurrencyMajorUnit(intl, choiceSubscription.currency.toUpperCase(), choiceSubscription.unit_amount / 100);
    const choiceSubscriptionFormattedPriceWithCoupon = coupon && choiceSubscription &&
        formatCurrencyMajorUnit(intl, choiceSubscription.currency.toUpperCase(), (choiceSubscription.unit_amount - (choiceSubscription.unit_amount * coupon.percent_off) / 100) / 100);

    const valueSubscriptionFormattedPrice = valueSubscription &&
        formatCurrencyMajorUnit(intl, valueSubscription.currency.toUpperCase(), valueSubscription.unit_amount / 100);
    const valueSubscriptionFormattedPriceWithCoupon = coupon && valueSubscription &&
        formatCurrencyMajorUnit(intl, valueSubscription.currency.toUpperCase(), (valueSubscription.unit_amount - (valueSubscription.unit_amount * coupon.percent_off) / 100) / 100);


    return (
        <div className={css.root}>
            <p className={css.title}>
                Annual Plans for Combined Accounts
            </p>
            <p style={{ textAlign: 'center' }}>
                So you can be both Sitter and Pet & Homeowner
            </p>
            <div className={css.container}>
                <div className={css.card}>
                    <div className={css.cardTitle}>
                        Combined Premium
                        <br />
                        Match Member
                    </div>

                    <div>
                        <div className={coupon ? css.cardPriceDiscounted : css.cardPrice}>
                            <span className={css.price}>
                                {premiumSubscriptionFormattedPrice}
                            </span>
                            per year
                        </div>
                        {coupon &&
                            <div className={css.cardPrice}>
                                <span className={css.price}>
                                    {premiumSubscriptionFormattedPriceWithCoupon}
                                </span>
                                per first year
                            </div>
                        }
                    </div>

                    <div className={css.button}
                        onClick={() => createSubscription(premiumSubscription.id)}>
                        Continue with Premium
                        <img className={css.icon} src={ContinueIcon} />
                    </div>
                    <ul className={css.list}>
                        <li>Unlimited home and pet care</li>
                        <li>Free housesitting and petsitting and homestays for you as a housesitter</li>
                        <li>Free home and pet care for you as a homeowner</li>
                        <li>Free onsite video calls with other members</li>
                        <li>See who has viewed or bookmarked your listing</li>
                        <li>Free video calls with Vets 24/7 Pet care</li>
                        <li>Account management support</li>
                        <li>Boost your listings</li>
                    </ul>
                </div>
                <div className={css.cardOffest}>
                    <div className={css.tag}>
                        Most popular
                    </div>
                    <div className={css.cardTitle}>
                        Combined Choice
                        <br />
                        Match Member
                    </div>

                    <div>
                        <div className={coupon ? css.cardPriceDiscounted : css.cardPrice}>
                            <span className={css.price}>
                                {choiceSubscriptionFormattedPrice}
                            </span>
                            per year
                        </div>
                        {coupon &&
                            <div className={css.cardPrice}>
                                <span className={css.price}>
                                    {choiceSubscriptionFormattedPriceWithCoupon}
                                </span>
                                per first year
                            </div>
                        }
                    </div>

                    <div className={css.button}
                        onClick={() => createSubscription(choiceSubscription.id)}>
                        Continue with Choice
                        <img className={css.icon} src={ContinueIcon} />
                    </div>

                    <ul className={css.list}>
                        <li>Unlimited home and pet care</li>
                        <li>Free housesitting and petsitting and homestays for you as a housesitter</li>
                        <li>Free home and pet care for you as a homeowner</li>
                        <li>Free onsite video calls with other members</li>
                        <li>See who has viewed or bookmarked your listing</li>
                        <li>Free video calls with Vets 24/7 Pet care</li>
                        <li>Account management support</li>
                        <li>Discounts for upgrades</li>
                    </ul>
                </div>
                <div className={css.card}>
                    <div className={css.cardTitle}>
                        Combined Value
                        <br />
                        Match Member
                    </div>

                    <div>
                        <div className={coupon ? css.cardPriceDiscounted : css.cardPrice}>
                            <span className={css.price}>
                                {valueSubscriptionFormattedPrice}
                            </span>
                            per year
                        </div>
                        {coupon &&
                            <div className={css.cardPrice}>
                                <span className={css.price}>
                                    {valueSubscriptionFormattedPriceWithCoupon}
                                </span>
                                per first year
                            </div>
                        }
                    </div>

                    <div className={css.button}
                        onClick={() => createSubscription(valueSubscription.id)}>
                        Continue with Standard
                        <img className={css.icon} src={ContinueIcon} />
                    </div>
                    <ul className={css.list}>
                        <li>One housesit advert at a time</li>
                        <li>Free housesitting and petsitting and homestays for you as a housesitter</li>
                        <li>Free home and pet care for you as a homeowner</li>
                        <li>Free onsite video calls with other members</li>
                        <li>See who has viewed or bookmarked your listing</li>
                        <li>Discounts for upgrades</li>
                    </ul>
                </div>
            </div>

            <SectionCoupon
                intl={intl}
                coupon={coupon}
                couponError={couponError}
                handleChange={handleChange}
                promoCode={promoCode}
                isBusy={isBusy}
                onApplyCoupon={onApplyCoupon}
            />
        </div>
    );
};

export default CombinedPlans;